module.exports = __webpack_public_path__ + "9ef0f9fac3a1cb29e054731b6acb93ff.png";